import { createStore } from 'vuex';
import * as config from '@/common/config';

let lifeData = {};

try {
    // 尝试获取本地是否存在lifeData变量，第一次启动APP时是不存在的
    let lifeDataJson = localStorage.getItem('touchLifeData');
    if(lifeDataJson) {
        lifeData = JSON.parse(lifeDataJson);
    }
} catch (e) {
    console.log(e);
}

// 需要永久存储，且下次APP启动需要取出的，在state中的变量名
let saveStateKeys = ['vuex_user_info', 'vuex_session_id'];

// 保存变量到本地存储中
const saveLifeData = function (key, value) {
    // 判断变量名是否在需要存储的数组中
    if (saveStateKeys.indexOf(key) != -1) {
        lifeData[key] = value;
        // 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
        localStorage.setItem('touchLifeData', JSON.stringify(lifeData));
    }
};
const store = createStore({
    // 下面这些值仅为示例，使用过程中请删除
    state: {
        vuex_user_info: lifeData.vuex_user_info ? lifeData.vuex_user_info : {},
        vuex_session_id: lifeData.vuex_session_id ? lifeData.vuex_session_id : '',
		vuex_client_config: config[process.env.VUE_APP_ENV || 'dev'].client,
    },
    mutations: {
        $uStore(state, payload) {
            // 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
            let nameArr = payload.name.split('.');
            let saveKey = '';
            let len = nameArr.length;
            if (nameArr.length >= 2) {
                let obj = state[nameArr[0]];
                for (let i = 1; i < len - 1; i++) {
                    obj = obj[nameArr[i]];
                }
                obj[nameArr[len - 1]] = payload.value;
                saveKey = nameArr[0];
            } else {
                // 单层级变量，在state就是一个普通变量的情况
                state[payload.name] = payload.value;
                saveKey = payload.name;
            }
            // 保存变量到本地，见顶部函数定义
            saveLifeData(saveKey, state[saveKey]);
        },
        $uDelete(state, key) {
            // 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
            let nameArr = key.split('.');
            let saveKey = '';
            let len = nameArr.length;
            if (nameArr.length >= 2) {
                let obj = state[nameArr[0]];
                for (let i = 1; i < len - 1; i++) {
                    obj = obj[nameArr[i]];
                }
                obj[nameArr[len - 1]] = undefined;
                saveKey = nameArr[0];
            } else {
                // 单层级变量，在state就是一个普通变量的情况
                state[key] = undefined;
                saveKey = key;
            }
            // 保存变量到本地，见顶部函数定义
            saveLifeData(saveKey, state[saveKey]);
        }
    }
});

export default store;
